/* eslint-disable react/no-unescaped-entities */
/* eslint-disable quotes */
import React from 'react'
import Section from '../components/Section'
import FilterItem from '../components/Atoms/FilterItem'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import QuickView from '../components/QuickView'

class Products extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			categoryListArr: [
				'Tops',
				'Bottoms',
				'Dresses',
				"Women's Yoga",
				'Bathing Suits',
				'Outer Wear',
				'Lingerie + Loungewear',
				'All Womens'
			],
			productsArr: [
				{
					title: 'The Etho Flowers in December Print Blouse',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 1'
				},
				{
					title: 'CeCe Wildflower Fling Top',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 1'
				},
				{
					title: 'The Etho Flowers in Her HAir Smock',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 2'
				},
				{
					title: 'CeCe Floral Print Puff Sleeve Top',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 2'
				},
				{
					title: 'Topshop Floral Pintuck Shirt',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 3'
				},
				{
					title: 'Topshop Floral Knot Front Shirt',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 3'
				},
				{
					title: 'Foxcroft Ava Ditsy Floral Print Shirt',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 4'
				},
				{
					title: 'Rip Curl Island Time Tie Strap Tank',
					price: Math.floor(Math.random() * 50) + 20,
					brand: 'Brand 5'
				}
			],
			quickviewItem: {},
			brandsToFilter: []
		}
	}

	handleQuickView = (e, product) => {
		e.preventDefault()
		this.setState(() => {
			return { quickviewItem: product }
		})

		document.querySelector('#quickview__modal').classList.add('show')
	}

	handleAddCart(e) {
		e.preventDefault()

		document
			.querySelector('#cart-drawer .container .row .col-12')
			.childNodes[3].insertAdjacentHTML(
				'afterend',
				`<div class='row cart-item'>
					<div class='col-12'>
						<img src='https://placehold.it/150' alt='placeholder' />
					</div>
					<div class='col-12'>
						<h4>${e.currentTarget.parentNode.dataset.title}</h4>
					</div>
					<div class='col-12'>
						<p>$59.99</p>
					</div>
				</div>`
			)
		if (
			!document.querySelector('#cart-drawer').classList.contains('show')
		) {
			document.querySelector('#cart-drawer').classList.add('show')
		}
	}

	handleFavorite = e => {
		e.preventDefault()
		e.currentTarget.classList.toggle('faved')
	}

	toggleDropdown = e => {
		e.currentTarget.classList.toggle('active')
	}

	handleFilter = e => {
		let brandsArr = []
		if (!e.currentTarget.classList.contains('activeFilter')) {
			e.currentTarget.classList.add('activeFilter')
		} else {
			e.currentTarget.classList.remove('activeFilter')
		}
		Array.from(document.querySelectorAll('.activeFilter')).forEach(
			activeFilter => {
				brandsArr.push(activeFilter.textContent)
			}
		)
		this.setState(() => {
			return { brandsToFilter: brandsArr }
		})
	}

	componentDidMount() {
		document.querySelectorAll('.brand').forEach(brand => {
			brand.addEventListener('click', this.handleFilter)
		})
	}

	render() {
		return (
			<div className='main-container'>
				<Section className='height-auto'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-sm-8 col-md-7 text-center'>
								<h2>Women's Tops</h2>
							</div>
						</div>
					</div>
				</Section>

				<Section id='category__section'>
					<div className='col-12'>
						<nav aria-label='breadcrumb'>
							<ol className='breadcrumb'>
								<li className='breadcrumb-item'>
									<a href='/'>Home</a>
								</li>
								<li className='breadcrumb-item '>
									<a href='/category'>Women</a>
								</li>
								<li
									className='breadcrumb-item active'
									aria-current='page'>
									Tops
								</li>
							</ol>
						</nav>
					</div>
					<div className='col-md-3'>
						<div className='el--sticky'>
							<h4>Filters:</h4>
							{/* Filter Column */}
							<ul>
								<li>
									<span
										className='active'
										onClick={this.toggleDropdown}>
										Women
									</span>
									<span className='plus-symbol' />
									<ul className='expandable-el'>
										{this.state.categoryListArr.map(
											(category, i) => {
												return (
													<li key={i}>
														<a href='/category/subcategory'>
															{category}
														</a>
													</li>
												)
											}
										)}
									</ul>
								</li>
								<li>
									<span onClick={this.toggleDropdown}>
										Brand
									</span>
									<span className='plus-symbol' />
									<ul className='expandable-el'>
										<FilterItem className='brand'>
											brand 1
										</FilterItem>
										<FilterItem className='brand'>
											brand 2
										</FilterItem>
										<FilterItem className='brand'>
											brand 3
										</FilterItem>
										<FilterItem className='brand'>
											brand 4
										</FilterItem>
										<FilterItem className='brand'>
											brand 5
										</FilterItem>
									</ul>
								</li>
								<li>
									<span onClick={this.toggleDropdown}>
										Colors
									</span>
									<span className='plus-symbol' />
									<ul className='expandable-el'>
										<FilterItem>black</FilterItem>
										<FilterItem>maroon</FilterItem>
										<FilterItem>yellow</FilterItem>
										<FilterItem>forest green</FilterItem>
										<FilterItem>heather gray</FilterItem>
									</ul>
								</li>
								<li>
									<span onClick={this.toggleDropdown}>
										Price
									</span>
									<span className='plus-symbol' />
									<ul className='expandable-el'>
										<FilterItem>under $50</FilterItem>
										<FilterItem>$50 - $100</FilterItem>
										<FilterItem>over $100</FilterItem>
									</ul>
								</li>
								<li>
									<span onClick={this.toggleDropdown}>
										Size
									</span>
									<span className='plus-symbol' />
									<ul className='expandable-el'>
										<FilterItem>xs</FilterItem>
										<FilterItem>sm</FilterItem>
										<FilterItem>md</FilterItem>
										<FilterItem>lg</FilterItem>
										<FilterItem>xl</FilterItem>
									</ul>
								</li>
							</ul>
						</div>
					</div>
					<div className='col-md-9'>
						<div className='row'>
							<div className='col-md-6'>
								<span>
									{this.state.categoryListArr.length} items
								</span>
								 |
								<span>Items per Page:&nbsp;</span>
								<span>40&nbsp;</span>
								<span>100</span>
							</div>
							<div
								id='sorting-tool'
								className='col-md-6 text-right'>
								<span className='bold'>Sort By:</span>
								<DropdownButton
									id='sort__dropdown'
									title='Sort'>
									<Dropdown.Item>Newest</Dropdown.Item>
									<Dropdown.Item>
										Price: Low -> High
									</Dropdown.Item>
									<Dropdown.Item>
										Price: High -> Low
									</Dropdown.Item>
									<Dropdown.Item>
										My{' '}
										<FAI
											icon='heart'
											color='rgba(231, 84, 128, 1)'
										/>
									</Dropdown.Item>
								</DropdownButton>
							</div>
						</div>
						{/* List of Categories */}
						<div className='row'>
							{this.state.productsArr.map((product, i) => {
								return (
									<div className='col-md-4' key={i}>
										<div className='card'>
											<a
												href='/category/subcategory/product'
												className='card-img-top pos--relative'
												data-title={product}>
												<FAI
													icon={['far', 'heart']}
													size='lg'
													color='rgb(231, 84, 128)'
													onClick={
														this.handleFavorite
													}
												/>
												<img
													src='https://placehold.it/240x360'
													alt='placeholder'
												/>
												<span
													className='btn'
													onClick={e => {
														this.handleQuickView(
															e,
															product
														)
													}}>
													<span className='btn__text'>
														Quickview
													</span>
												</span>
												<span
													className='btn btn--secondary'
													onClick={
														this.handleAddCart
													}>
													<span className='btn__text'>
														Add to Cart
													</span>
												</span>
											</a>
											<div className='card-body'>
												<h4 className='card-title'>
													{product.title}
												</h4>
												<ul className='product-colors'>
													<li
														data-color='pink'
														className='product-color active'
													/>
													<li
														data-color='forest-green'
														className='product-color'
													/>
													<li
														data-color='yellow'
														className='product-color'
													/>
													<li
														data-color='black'
														className='product-color'
													/>
												</ul>
												<span className='semi-bold'>
													${product.price}
													.99&nbsp;
												</span>
												<span className='text-muted'>
													New!
												</span>
												<p className='card-text'>
													Lorem ipsum dolor sit amet
													consectetur adipisicing
													elit. Temporibus, eaque.
												</p>
											</div>
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</Section>

				<Section id='cta__section'>
					<div className='col-md-6'>
						<img
							src='https://placehold.it/600x400'
							alt='placeholder'
						/>
					</div>
					<div className='col-md-6'>
						<img
							src='https://placehold.it/600x400'
							alt='placeholder'
						/>
					</div>
				</Section>

				<QuickView
					item={this.state.quickviewItem}
					addToCart={this.handleAddCart}
				/>
			</div>
		)
	}
}

export default Products
